import Fader from "../common/view/Fader";

class Loading {
  // ---------------------------------------------------------------------------------------------------------
  // --	Loading
  // ---------------------------------------------------------------------------------------------------------

  constructor() {
    console.log("Loading");

    //DOM参照
    this.$loading = $(".loading");
    this.$bar = this.$loading.find(".bar");
    this.$txt = this.$loading.find(".loading__txt");

    //フェーダー
    this.fader = new Fader();
  }

  /**
   * 表示
   */
  show(callback) {
    //表示初期化
    this.$loading.css("display", "flex");
    gsap.set(this.$loading, { alpha: 0 });
    gsap.set(this.$bar, { width: "0%" });
    gsap.set(this.$txt, { alpha: 0, y: 100 });

    //フェードイン
    this.fader.changeCategory();
    this.fader.show(() => {
      gsap.to(this.$loading, 0.5, {
        alpha: 1,
        onComplete: () => {
          gsap.to(this.$txt, 0.3, {
            alpha: 1,
            ease: "none",
          });
          gsap.to(this.$txt, 0.6, {
            y: 0,
            ease: "elastic.out(1, 0.3)",
          });
          gsap.to(this.$bar, 3, {
            width: "100%",
            ease: "none",
            onComplete: () => {
              gsap.to(this.$loading, 0.5, {
                alpha: 0,
                ease: "none",
                onComplete: () => {
                  callback();
                },
              });
            },
          });
        },
      });
    });
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Loading;
